import React from "react";
import { FallsIcon } from "../../atoms/FallsIcon";
import { FallIncidentCard } from "../../molecules/FallIncidentCard";
import { FallIncidentsResponse } from "../../../types/residents";

interface FallIncidentsSectionProps {
  data: FallIncidentsResponse | null;
  isLoading: boolean;
  error: Error | null;
}

export const FallIncidentsSection: React.FC<FallIncidentsSectionProps> = ({
  data,
  isLoading,
  error,
}) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="py-4 text-center text-muted-foreground">
          Loading fall incidents...
        </div>
      );
    }

    if (error) {
      return (
        <div className="py-4 text-center text-destructive">
          Error loading fall incidents: {error.message}
        </div>
      );
    }

    if (!data || data.incidents.length === 0) {
      return (
        <div className="py-4 text-center text-muted-foreground">
          No recent fall incidents
        </div>
      );
    }

    return (
      <div className="flex flex-col gap-4">
        {data.incidents.map((incident, index) => (
          <FallIncidentCard
            key={incident.id || index}
            incident={incident}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="space-y-4">
      {/* Section Header */}
      <div className="flex items-center gap-2">
        <FallsIcon className="w-5 h-5 text-orange-600" />
        <h2 className="text-lg font-semibold text-gray-900">Fall Incidents</h2>
        {data && data.count > 0 && (
          <span className="text-sm text-gray-600">({data.count})</span>
        )}
      </div>

      {renderContent()}
    </div>
  );
};
